import BaseAPI from './base/base-api'

/**
 * Đầu api để gọi vào controller: TaxReturnSubmissionController
 */
class TaxReturnSubmissionAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'DeclareAPI';
    controllerName = 'taxreturnsubmission';
}

export default new TaxReturnSubmissionAPI();